export default __webpack_public_path__ + "static/media/ttt-dot-com-bg3.f10bf3c4.svg";